:host {
  --uui-tab-background: none;
  --uui-tab-color: var(--uui-theme-variant-400);
  --uui-tab-line-height: var(--uui-small-line-height);
  --uui-tab-padding-top: 0;
  --uui-tab-padding-right: 1.25rem;
  --uui-tab-padding-left: 1.25rem;
  --uui-tab-padding-bottom: 0.5rem;
  --uui-tab-padding-hover-bottom: 0.6875rem;
  --uui-tab-border: 0 solid transparent;
  --uui-tab-border-color: transparent;
  --uui-tab-border-bottom-width: 0.25rem;
  --uui-tab-border-bottom-hover-width: 0.06rem;
  --uui-tab-border-left-width: 0;
  --uui-tab-border-width: 0;
  --uui-tab-divider-width: 4px;
  --uui-tab-margin-right: var(--uui-small-gap); 
  --uui-tab-text-transform: uppercase;
  --uui-tab-height: 2rem;
  --uui-tab-justify-content: center;
  --uui-tab-align-items: center;
  --uui-tab-disabled-opacity: 0.35;
}

:host-context([orientation="vertical"]) {
  --uui-tab-height: 2.75rem;
  --uui-tab-line-height: var(--uui-large-line-height);
  --uui-tab-justify-content: flex-start;
  --uui-tab-padding-top: 0.375rem;
  --uui-tab-padding-right: 1.25rem;
  --uui-tab-padding-left: 1.25rem;
  --uui-tab-padding-hover-left: 1.4375rem;
  --uui-tab-padding-bottom: 0.375rem;
  --uui-tab-padding-hover-bottom: 1.4375rem;
  --uui-tab-border-left-width: 0.25rem;
  --uui-tab-border-left-hover-width: 0.06rem;
  --uui-tab-border-bottom-width: 0;
  --uui-tab-border-bottom-hover-width: 0.0;
}

:host-context([orientation="horizontal"]) {
  display: inline-block;
  align-self: flex-end;
}

:host([active]:not([active="false"])) {
  --uui-tab-color: var(--uui-theme-core-600);
  --uui-tab-border-color: var(--uui-tab-color);
}

/* Non-variable host values */
:host {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-default-font-size);
  font-weight: var(--uui-font-weight-bold);
}

:host-context([orientation="vertical"]) {
  margin-bottom: 0.5rem;
  font-size: var(--uui-large-font-size);
  font-weight: var(--uui-font-weight-light);
}

:host([active]:not([active="false"])):host-context([orientation="vertical"]) {
  font-weight: var(--uui-font-weight-bold);
}

button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  height: auto;
  min-height: var(--uui-tab-height);
  width: 100%;
  line-height: var(--uui-tab-line-height);
  padding-top: var(--uui-tab-padding-top);
  padding-right: var(--uui-tab-padding-right);
  padding-left: var(--uui-tab-padding-left);
  padding-bottom: var(--uui-tab-padding-bottom);
  color: var(--uui-tab-color);
  border: var(--uui-tab-border);
  border-color: var(--uui-tab-border-color);
  border-left-width: var(--uui-tab-border-left-width);
  border-bottom-width: var(--uui-tab-border-bottom-width);
  display: flex;
  align-items: var(--uui-tab-align-items);
  justify-content: var(--uui-tab-justify-content);
  text-transform: var(--uui-tab-text-transform);
}

/* hover state */
:host-context([orientation="horizontal"]):host(:not([disabled="true"]):not([disabled]):not([active]):not([active="true"])) button:hover,
:host-context([orientation="horizontal"]):host([active="false"]) button:hover {
  --uui-tab-border-color: var(--uui-tab-color);
  --uui-tab-padding-bottom: var(--uui-tab-padding-hover-bottom);
  --uui-tab-border-bottom-width: var(--uui-tab-border-bottom-hover-width);
}

:host-context([orientation="vertical"]):host(:not([disabled="true"]):not([disabled]):not([active]):not([active="true"])) button:hover,
:host-context([orientation="vertical"]):host([active="false"]) button:hover {
  --uui-tab-border-color: var(--uui-tab-color);
  --uui-tab-padding-left: var(--uui-tab-padding-hover-left);
  --uui-tab-border-left-width: var(--uui-tab-border-left-hover-width);
}


[name="icon"]::slotted(*) {
  margin-right: var(--uui-tab-divider-width);
  width: 1.25rem;
  color: var(--uui-tab-color);
  fill: var(--uui-tab-color);
}

:host-context([orientation="horizontal"]):host-context([type="icon"]) {
  margin-right: var(--uui-tab-margin-right);
}

/** disabled state */
:host([disabled]) {
  opacity: var(--uui-tab-disabled-opacity);
}

:host([disabled]) button:hover {
  cursor: default;
}


:host-context([type="icon"]) {
  --uui-tab-border-color: none;
  --uui-tab-padding-bottom: 0;
  --uui-tab-border-bottom-width: 0;
}